import { useEffect, useState } from "react";
import axios from "axios";

import API_URL from "../config/config";
import AdminSidebar from "../components/AdminSidebar";
import "../css/admin.css";
import { useNavigate } from "react-router-dom";
import {
    FaEdit,
    FaTrash,
    FaSave,
    FaTimes
} from "react-icons/fa";


function AdminProducts() {


    const [products, setProducts] = useState([]);

    const [search, setSearch] = useState("");

    const [editingProduct, setEditingProduct] = useState(null);



    useEffect(() => {

        loadProducts();

    }, []);



    // ==========================
    // LOAD PRODUCTS
    // ==========================

    const loadProducts = () => {


       axios.get(
    `${API_URL}/admin/products`,
    {
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
        }
    }
)

        .then((res)=>{

            setProducts(res.data);

        })

        .catch((err)=>{

            console.log(err);

        });


    };




    // ==========================
    // DELETE PRODUCT
    // ==========================

    const deleteProduct = (id)=>{


        if(!window.confirm("Delete this product?"))
        {
            return;
        }

axios.delete(
    `${API_URL}/admin/products/${id}`,
    {
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
        }
    }
)

        .then(()=>{

            alert("Product Deleted Successfully");

            loadProducts();

        })

        .catch((err)=>{

            console.log(err);

        });


    };





    // ==========================
    // EDIT CLICK
    // ==========================

    const editProduct = (product)=>{


        setEditingProduct({

            ...product

        });


    };





    // ==========================
    // INPUT CHANGE
    // ==========================

    const handleEditChange = (e)=>{


        setEditingProduct({

            ...editingProduct,

            [e.target.name]:e.target.value

        });


    };




const navigate = useNavigate();

useEffect(() => {

    const role = localStorage.getItem("role");

    if (role !== "admin") {

        alert("Access Denied");

        navigate("/");

    }

}, [navigate]);

    // ==========================
    // UPDATE PRODUCT
    // ==========================

    const updateProduct = ()=>{

axios.put(

    `${API_URL}/admin/products/${editingProduct.id}`,

    editingProduct,

    {
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
        }
    }

)


        .then(()=>{


            alert("Product Updated Successfully");


            setEditingProduct(null);


            loadProducts();


        })


        .catch((err)=>{

            console.log(err);

        });


    };





return (

<div className="admin-layout">


<AdminSidebar />


<div className="admin-content">


<h1>
Products Management
</h1>



<input

className="admin-search"

placeholder="Search Product..."

value={search}

onChange={(e)=>setSearch(e.target.value)}

/>





{/* ================= EDIT BOX ================= */}


{
editingProduct && (


<div className="edit-product-box">


<h2>
Edit Product
</h2>




<input

name="product_name"

placeholder="Product Name"

value={editingProduct.product_name || ""}

onChange={handleEditChange}

/>




<input

name="category"

placeholder="Category"

value={editingProduct.category || ""}

onChange={handleEditChange}

/>





<input

name="brand"

placeholder="Brand"

value={editingProduct.brand || ""}

onChange={handleEditChange}

/>





<textarea

name="description"

placeholder="Description"

value={editingProduct.description || ""}

onChange={handleEditChange}

/>






<input

type="number"

name="price"

placeholder="Price"

value={editingProduct.price || ""}

onChange={handleEditChange}

/>






<input

type="number"

name="old_price"

placeholder="Old Price"

value={editingProduct.old_price || ""}

onChange={handleEditChange}

/>






<input

type="number"

name="discount"

placeholder="Discount"

value={editingProduct.discount || ""}

onChange={handleEditChange}

/>






<input

type="number"

name="stock"

placeholder="Stock"

value={editingProduct.stock || ""}

onChange={handleEditChange}

/>





<select

name="status"

value={editingProduct.status}

onChange={handleEditChange}

>


<option value="Active">
Active
</option>


<option value="Inactive">
Inactive
</option>


</select>





<button

className="edit-btn"

onClick={updateProduct}

>

<FaSave />

Save Product

</button>





<button

className="delete-btn"

onClick={()=>setEditingProduct(null)}

>

<FaTimes />

Cancel

</button>



</div>


)

}







{/* ================= PRODUCTS TABLE ================= */}



<table className="admin-table">


<thead>

<tr>

<th>ID</th>

<th>Image</th>

<th>Name</th>

<th>Category</th>

<th>Price</th>

<th>Stock</th>

<th>Action</th>


</tr>


</thead>





<tbody>


{

products

.filter((p)=>

p.product_name

.toLowerCase()

.includes(search.toLowerCase())

)


.map((item)=>(


<tr key={item.id}>


<td>
{item.id}
</td>





<td>


<img

src={`${API_URL.replace("/api","")}${item.image}`}

alt={item.product_name}

width="60"

/>


</td>






<td>
{item.product_name}
</td>





<td>
{item.category}
</td>





<td>
${item.price}
</td>





<td>
{item.stock}
</td>






<td>


<button

className="edit-btn"

onClick={()=>editProduct(item)}

>

<FaEdit />

Edit

</button>





<button

className="delete-btn"

onClick={()=>deleteProduct(item.id)}

>

<FaTrash />

Delete

</button>




</td>





</tr>


))


}



</tbody>



</table>





</div>


</div>


);


}


export default AdminProducts;